import axios from 'axios';
import auth from './auth';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.common['x-app-id'] = process.env.VUE_APP_ID;

export default {
  auth
};
